import React from 'react';

import type { DrawerContextType } from './DrawerContextType';

export const DrawerContext = React.createContext<
  DrawerContextType | undefined
>(undefined);
